export { default as TitleWithImage } from './TitleWithImage';
